import { render, staticRenderFns } from "./ConfiguracionCorte.vue?vue&type=template&id=1b569716&"
import script from "./ConfiguracionCorte.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionCorte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports